import { makeWasmObservable } from 'libs/rendering/gltf/api/wasmObservable';

export class CadFile {
  // we pass the wasm module (wftyModule) as arg to the constructor
  constructor(viewerControl, fileId) {
    this._fileId = fileId;
    this._isOk = true;

    this.viewerControl = viewerControl;
    const { wftyModule } = this.viewerControl;
    try {
      this._wasm = new wftyModule.CadFileEmbind(this._fileId);
    } catch (e) {
      this.viewerControl.LogFail(e.toString());
    }
  }

  get isOk() {
    // TODO: this previously only checked the connection status, there is no
    // other (error)status to check in CadFile currently, but we should probably
    // have one
    return true;
  }

  get metadata() {
    if (this.isOk) {
      try {
        return this._wasm.GetMetaData();
      } catch (e) {
        this.viewerControl.LogException(e.toString());
      }
    }
    return null;
  }

  get unitLabel() {
    if (this.isOk) {
      try {
        return this._wasm.GetModelUnitsLabel();
      } catch (e) {
        this.viewerControl.LogException(e.toString());
      }
    }
    return null;
  }

  // Assembly: the assembly 'product structure' tree (all 'parts' present in the CadFile and their tree structure)
  get assembly() {
    if (this.isOk) {
      try {
        const { obsMap } = this.viewerControl;
        return makeWasmObservable(
          obsMap,
          this._wasm.GetAssembly(),
          this.viewerControl,
        );
      } catch (e) {
        this.viewerControl.LogException(e.toString());
      }
    }
    return null;
  }

  // PMI: Product Manufacturing Information
  get pmi() {
    if (this.isOk) {
      try {
        const { obsMap } = this.viewerControl;
        return makeWasmObservable(
          obsMap,
          this._wasm.GetPMI(),
          this.viewerControl,
        );
      } catch (e) {
        this.viewerControl.LogException(e.toString());
      }
    }
    return null;
  }

  destroy = () => {
    try {
      this._wasm.delete();
    } catch (e) {
      this.viewerControl.LogException(e.toString());
    }
  };
}
